var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-form" },
    [
      _c("h1", { staticClass: "form-title" }, [_vm._v("Summer Communication")]),
      _c("p", { staticClass: "text big bold mt-30" }, [
        _vm._v(
          "Will you be unable to communicate with us at any point over the summer?"
        )
      ]),
      _c("RadioGroup", {
        staticClass: "mt-10 checkboxgroup-wrap inp-wrap large",
        attrs: { options: _vm.GROUP_OPTIONS, value: _vm.value.can_communicate },
        on: {
          input: function($event) {
            return _vm.handleInput($event, "can_communicate")
          }
        }
      }),
      _c("p", { staticClass: "text bold big mt-30" }, [
        _vm._v("If so, please give the dates and reason you'll be unavailable.")
      ]),
      _c(
        "div",
        { staticClass: "inp-wrap mt-20 large" },
        [
          _c("Textarea", {
            attrs: { counter: false, placeholder: "", value: _vm.value.reason },
            on: {
              input: function($event) {
                return _vm.handleInput($event, "reason")
              }
            }
          })
        ],
        1
      ),
      _c("p", { staticClass: "text bold big mt-30" }, [
        _vm._v(
          "Please provide the best emergency communication method for the summer."
        )
      ]),
      _c("p", { staticClass: "text mt-10" }, [
        _vm._v("Phone, WeChat, Facebook, etc.")
      ]),
      _c(
        "div",
        { staticClass: "inp-wrap mt-20 large" },
        [
          _c("Textarea", {
            attrs: {
              counter: false,
              placeholder: "",
              value: _vm.value.communication_method
            },
            on: {
              input: function($event) {
                return _vm.handleInput($event, "communication_method")
              }
            }
          })
        ],
        1
      ),
      _c(
        "Button",
        { staticClass: "btn-submit", on: { click: _vm.handleClickSubmit } },
        [_vm._v("Submit")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }